module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "collections-index"
  }, [_c('section', _vm._l((_vm.collectionsSorted), function(item) {
    return (!_vm.isHidden(item)) ? _c('router-link', {
      key: item.id,
      attrs: {
        "to": '/collections/' + item.uid
      }
    }, [_c('article', [_c('header', {
      staticClass: "sticky-header uppercase"
    }, [_c('h2', {
      staticClass: "h4"
    }, [(!_vm.isBespoke(item)) ? [_vm._v("\n              Collection\n            ")] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (item.getText('collection.number')) ? [_vm._v("\n              Nr. "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.getText('collection.number'))
      }
    }), _vm._v(" "), _c('br')] : _vm._e(), _vm._v(" "), (_vm.isBespoke(item)) ? [_vm._v("\n              Dovedale Design"), _c('br'), _vm._v("Studio’s"), _c('br')] : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(item.getText('collection.title'))
      }
    })], 2), _vm._v(" "), _c('nav', {
      staticClass: "h8 is-hidden-mobile"
    }, [(_vm.isBespoke(item)) ? [_c('a', [_vm._v("View Gallery")]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/collections/' + item.uid + '/items'
      }
    }, [_vm._v("Enquire")])] : [_c('a', [_vm._v("View Collection")]), _vm._v(" "), _c('router-link', {
      attrs: {
        "to": '/collections/' + item.uid + '/items'
      }
    }, [_vm._v("Purchase Collection")])]], 2)]), _vm._v(" "), _c('section', _vm._l((item.getGroup('collection.index-images').toArray()), function(photo) {
      return _c('div', {
        style: ({
          backgroundImage: 'url(' + _vm.respImgUrl(photo) + ')'
        })
      })
    }), 0)])]) : _vm._e()
  }), 1), _vm._v(" "), _c('appfooter', {
    attrs: {
      "site": _vm.site
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b67230e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Collections.vue
// module id = 393
// module chunks = 1